// Resume uploads accepted by the portal. The API accepts the same types
// (PDF, DOC, DOCX); keep the two in step.
export const RESUME_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const RESUME_ACCEPT = ".pdf,.doc,.docx";

export const RESUME_MAX_BYTES = 5 * 1024 * 1024;
